import script from "./Survey.vue?vue&type=script&setup=true&lang=js"
export * from "./Survey.vue?vue&type=script&setup=true&lang=js"

import "./Survey.vue?vue&type=style&index=0&id=013d2a6d&lang=css"

const __exports__ = script;

export default __exports__